uniform sampler2D map;
uniform vec2 uRepeat;

varying vec2 vOffset;

void main() {

    vec2 uv = vec2( gl_PointCoord.x, 1.0 - gl_PointCoord.y );

    vec4 tex = texture2D( map, (uv * uRepeat) + vOffset );
    
    if ( tex.a < 0.5 ) discard;

    gl_FragColor = tex;
    //gl_FragColor = vec4(uv.y, 0.0, 0.0, 1.0);

}
